import React from 'react';
import { Provider } from 'react-redux';
import createStore, { setAsCurrentStore } from "../store/store";
import toString from './toString';
import { createRoot as ReactDOMCreateRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { getInitialState, getPrefix, rest } from "@karpeleslab/klbfw";
import Layout from "../components/layout/Layout";
import { HelmetProvider } from 'react-helmet-async';

import { prerequisites } from "./routeConfig";

import '../i18n';  // Correct import path

// Function to initialize the app with React 19's createRoot
function initializeApp(store) {
    const container = document.getElementById('root');
    const root = ReactDOMCreateRoot(container);
    
    root.render(
        <Provider store={store}>
            <HelmetProvider>
                <BrowserRouter basename={getPrefix() + "/"}>
                    <Layout />
                </BrowserRouter>
            </HelmetProvider>
        </Provider>
    );
}

export function run() {
    // Export rest for debugging
    if (process.env.NODE_ENV !== 'production') {
        window.rest = rest;
    }

    const initState = getInitialState();
    const store = createStore(initState);
    setAsCurrentStore(store);

    if (initState) initializeApp(store);
    else {
        Promise.all(prerequisites(store))
            .then(() => initializeApp(store))
    }
}

export const renderToString = toString;
